import { render, staticRenderFns } from "./multipleSelectTeam.vue?vue&type=template&id=513d8292&"
import script from "./multipleSelectTeam.vue?vue&type=script&lang=ts&"
export * from "./multipleSelectTeam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports